export default __webpack_public_path__ + "img/23a9386825e4eb45a4423223808c95e0.svg";